import { Module, MutationTree } from 'vuex';

import clients from './clients';
import business from './business';
import soleTrader from './soleTrader';
import privateOrdersIntegration from './private-orders-integration';
import publicOrdersIntegration from './public-orders-integration';
import information from './information';
import fulfillment from './fulfillment';
import productsIntegration from './account-products/products-integration';
import billing from './billing';
import orderpay from '@client/monolith/legacy/store/account/orderpay';
import { ToasterConfigType } from '@ankorstore/design-system';
import { SaveBarMode } from './types';
import paymentConfiguration from '@monolith/legacy/store/account/payment-configuration';
import nafoCustomer from '@monolith/legacy/store/account/nafo-customer';
import fulfillableItems from '@monolith/legacy/store/account/fulfillable-items';

export interface AccountState {
  saveBarMode: SaveBarMode;
  saveBarCustomPlacement: boolean;
  discardChangesNotificationActive: boolean;
  routeTo: string;
  isPopinDisplayed: boolean;
  isSaveBarPending: boolean;
}

export const createInitialState = (): AccountState => ({
  saveBarMode: SaveBarMode.Disabled,
  saveBarCustomPlacement: false,
  discardChangesNotificationActive: true,
  routeTo: null,
  isPopinDisplayed: false,
  isSaveBarPending: false,
});

export const mutations: MutationTree<AccountState> = {
  SET_SAVEBAR_MODE(state: AccountState, type: SaveBarMode): void {
    state.saveBarMode = type;
  },
  SET_DISCARD_STATUS(state: AccountState, value: boolean): void {
    state.discardChangesNotificationActive = value;
  },
  SET_SAVEBAR_PLACEMENT(state: AccountState, value: boolean): void {
    state.saveBarCustomPlacement = value;
  },

  SET_SAVEBAR_PENDING(state: AccountState, pending: boolean): void {
    state.isSaveBarPending = pending;
  },
  SET_DISPLAYED_POPIN(state: AccountState, value: boolean): void {
    state.isPopinDisplayed = value;
  },
};

export const actions = {
  changeSaveBarMode({ state, commit }, type: SaveBarMode): void {
    if (type !== state.saveBarMode) {
      commit('SET_SAVEBAR_MODE', type);
    }
  },
  setDiscardChangesNotificationActive({ state, commit }, value: boolean): void {
    if (value !== state.discardChangesNotificationActive) {
      commit('SET_DISCARD_STATUS', value);
    }
  },
  setSaveBarCustomPlacement({ commit }, isCustom: boolean): void {
    commit('SET_SAVEBAR_PLACEMENT', isCustom);
  },
  setSaveBarPending({ commit }, disabled: boolean): void {
    commit('SET_SAVEBAR_PENDING', disabled);
  },
  displayDiscardChanges(): void {},
  setAsDisplayedPopin({ commit }, value: boolean): void {
    commit('SET_DISPLAYED_POPIN', value);
  },
  //payload is needed to pass propsto the toaster via subscribed actions
  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  displayAccountToaster(_payload: ToasterConfigType): void {},
};

export const getters = {
  getSaveBarMode: (state: AccountState): SaveBarMode => state.saveBarMode,
  isSaveBarCustomPlacement: (state: AccountState): boolean => state.saveBarCustomPlacement,
  isDiscardChangesNotificationActive: (state: AccountState): boolean => state.discardChangesNotificationActive,
  isSaveBarEnabled: (state: AccountState): boolean => state.saveBarMode !== SaveBarMode.Disabled,
  isPopinDisplayed: (state: AccountState): boolean => state.isPopinDisplayed,
  isSaveBarPending: (state: AccountState): boolean => state.isSaveBarPending,
};

export default {
  namespaced: true,
  state: createInitialState(),
  modules: {
    clients,
    business,
    soleTrader,
    privateOrdersIntegration,
    publicOrdersIntegration,
    information,
    fulfillment,
    productsIntegration,
    paymentConfiguration,
    nafoCustomer,
    fulfillableItems,
    billing,
    orderpay,
  },
  actions,
  mutations,
  getters,
} as unknown as Module<AccountState, unknown>;
